



















import { Vue, Prop, Component } from 'vue-property-decorator';
import PromptBar from './PromptBar.vue';
@Component({
  components: {
    PromptBar,
  },
})
export default class RevisionPromptBar extends Vue {
  @Prop() timeLeft: number;
  @Prop() sender: string;
  @Prop({ default: false }) loading: boolean;
  @Prop({ default: false }) isDsr?: boolean;

  get title(): string {
    return this.isDsr
      ? this.$t('dsr_updated_room_title', {
          SenderName: this.sender,
        }).toString()
      : `${this.sender} ${this.$t('has-modified-the-document')}`;
  }

  get secondsText(): string {
    return this.timeLeft === 1 ? this.$t('second').toString() : this.$t('seconds').toString();
  }

  get description(): string {
    return this.isDsr
      ? `${this.$t('dsr_updated_room_description').toString()} ${this.timeLeft} ${this.secondsText}`
      : `${this.$t('the-document-will-automatically-update-in').toString()} ${this.timeLeft} ${
          this.secondsText
        }`;
  }

  get cta(): string {
    return this.isDsr
      ? this.$t('dsr_update_button').toString()
      : this.$t('review-new-version').toString();
  }
}
